import Swiper, { EffectFade } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';

export default class {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = this.dom.el.querySelector('.swiper');
    this.dom.tabs = this.dom.el.querySelectorAll('[data-swpr="tab"]');

    // HTMLCollectionから配列を作成
    this.elements = [].slice.call(this.dom.tabs);

    this.slider = null;
    this.option = {
      modules: [EffectFade],
      init: false,
      // loop: true,
      speed: 1800,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      slidesPerView: 1,
      noSwiping: false,
    };

    this.init();
  }

  init() {
    const _this = this;
    this.slider = new Swiper(this.dom.slider, this.option);
    this.slider.init();

    [...this.dom.tabs].forEach(el=> {
      el.addEventListener('click', e => {
        const currentSelected = _this.dom.el.querySelector('[data-is="selected"]');
        currentSelected.removeAttribute('data-is');
        e.currentTarget.dataset.is = 'selected';
        _this.slideChange(_this.getIndex(e.currentTarget));
      })
    });
  }

  getIndex(_target) {
    console.log(this.elements.indexOf(_target));
    return this.elements.indexOf(_target);
  }

  slideChange(_index) {
    this.slider.slideTo(_index);
  }

  destroy() {
    this.slider.destroy(true, true);
  }
}
